import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../services/authentication/authContext';
import { hasAccountSetting } from '../services/accessManagement/accountSettingsUtils';
import { useImpersonationStore } from '../stores/appImpersonationStore';

export function AmbassadorRoute({ children }: { children: JSX.Element }) {
  const { t } = useTranslation();
  const { user, backendUser, accountSettings, loading } = useAuth();
  const target = useImpersonationStore(state => state.target);
  if (!loading && !user) return <Navigate to="/login" replace />;
  if (loading || !backendUser || backendUser.id !== (target?.userId ?? user?.id)) {
    return <p className="p-6 text-textPrimary dark:text-textPrimary-dark" role="status">{t('ambassador.loading')}</p>;
  }
  return backendUser.role === 'admin' && hasAccountSetting('ambassador', backendUser, accountSettings)
    ? children : <Navigate to="/" replace />;
}
